'use strict';

/**
 * Module definition file
 */

var flux = angular.module('saturn.flux', []);

var FluxUtil = require('./FluxUtil');
var Event = require('./lib/Event');

flux.service('sbFlux', FluxUtil);
flux.service('sbFluxEvent', Event);



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/index.js